import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TechCheckRequestDetailsComponent} from './components/tech-check-request-details/tech-check-request-details.component';
import {TechCheckLogComponent} from './components/tech-check-request-details/tech-check-log/tech-check-log.component';
import {AuthGuard} from './services/auth.guard';

const routes: Routes = [
  {
    path: 'request-details/:requestNumber/domain/:domain/tech-check/:techCheckID',
    component: TechCheckRequestDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ':changeRequestID/tech-check-log/:techCheckTestId',
    component: TechCheckLogComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  // @ts-ignore
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommonDomainRoutingModule { }
